'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

require('antd/lib/switch/style/css');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Switch = (0, _component2.default)(function () {
  return import('antd/lib/switch');
});

var IDSwitch = function (_BaseComponent) {
  (0, _inherits3.default)(IDSwitch, _BaseComponent);

  function IDSwitch(props) {
    (0, _classCallCheck3.default)(this, IDSwitch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDSwitch.__proto__ || (0, _getPrototypeOf2.default)(IDSwitch)).call(this, props));

    _this.handleChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      _this.setValue(value);
    };

    _this.onClear = function () {
      _this.setValue(false);
    };

    _this.renderBody = function () {
      var _this$props2 = _this.props,
          refId = _this$props2.refId,
          name = _this$props2.name,
          checkedChildren = _this$props2.checkedChildren,
          unCheckedChildren = _this$props2.unCheckedChildren;
      var value = _this.state.value;

      if (checkedChildren || unCheckedChildren) {
        return _react2.default.createElement(Switch, (0, _extends3.default)({}, _this.props, {
          checked: Boolean(value),
          onChange: _this.handleChange
        }));
      }

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement('input', {
          id: refId || _this.id,
          type: 'checkbox',
          className: 'inp-swt',
          checked: Boolean(value),
          onChange: function onChange(event) {
            return _this.handleChange(event.target.checked);
          },
          style: { display: 'none' },
          name: name
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: refId || _this.id, className: 'toggle-switch' },
          _react2.default.createElement('span', null)
        )
      );
    };

    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.id = 'switch_' + Math.random().toString().replace(/0\./, '');
    _this.dataTestID = 'switch';
    return _this;
  }

  (0, _createClass3.default)(IDSwitch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          disabled = _props.disabled;

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)(className, { 'input-disabled': disabled }),
          style: style
        },
        this.renderBody()
      );
    }
  }]);
  return IDSwitch;
}(_BaseComponent3.default);

exports.default = IDSwitch;